<template>
    <c-rating-container v-show="item.pro_rating || item.points" :class="[layoutLeft ? 'align-rating-left' : 'align-rating']">
        <div>
            <c-rating :ratings="rating"></c-rating>
        </div>
        <a  
            :href="showTotalReviews ? '#review-link' : '#'" 
            class="rating-link"
            aria-label="Total de avaliações"
        >   
            {{item.pro_rating ? getTotalReviews(item) : null}}
        </a>
    </c-rating-container>
</template>

<script>
import { CRating, CRatingContainer } from '../Styles/Product/styled';
import {getRating} from '../../services/product';

export default {
    name: 'Rating', 
    props: {
        item: {
            required: true,
            type: Object,
        },
        showTotalReviews: {
            default:false,
            type: Boolean
        },
        layoutLeft: {
            default: false
        }
    },
    components: {
        'c-rating': CRating,
        'c-rating-container': CRatingContainer,
    },
    methods: {
        getTotalReviews(item) {
            let total = item.total_comentarios
            if(!total) return null
            if(this.showTotalReviews) {
                return total > 1 ? '('+total+' Avaliações)' : '('+total+' Avaliação)'
            } 
            return '('+total+')'
        }
    },
    computed: {
        rating() {
            return getRating(this.item?.pro_rating ?? this.item.points)
        }
    }
}
</script>